/* React */
import React from 'react';
import { useAuth } from '../../../../hooks/auth';
import { HeaderMenu } from '../../../../components/HeaderMenu';
import { Link } from 'react-router-dom';

import { Container, MidContent, RightContent, Button } from './styles';

import logoWhite from '../../../../assets/img/logoWhite.png';

import { FiLogOut } from 'react-icons/fi';
import { IoIosNotifications } from 'react-icons/io';

export const Header: React.FC = () => {
  const { logOut } = useAuth();

  return (
    <Container>
      <HeaderMenu />
      <MidContent>
        <img src={logoWhite} alt="logo" />
      </MidContent>
      <RightContent>
        <Link to="/leagues/user/notifications">
          <IoIosNotifications size={25} />
        </Link>
        <Button buttonColor="purple" onClick={logOut}>
          <p>Sair</p>
          <FiLogOut size={20} />
        </Button>
      </RightContent>
    </Container>
  );
};
